import {useStringQueryParameter} from 'lib/hooks/use-router-query'

import Regions from '../client'

export const useRegion = Regions.createUseOne()
export const useRegions = Regions.createUseMany()

/**
 * Get the current region ID from the query parameters.
 */
export function useCurrentRegionId(): string | undefined {
  return useStringQueryParameter('regionId')
}

/**
 * The application is mostly used in the context of a single region whose ID is always present in
 * the URL. This helper function prevents the need to drill the `regionId` down into each component.
 */
export function useCurrentRegion() {
  const response = useRegion(useCurrentRegionId())
  return response.data
}
